var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import log from 'loglevel';
import { createConsoleLoggerFactory, createHttpLoggerFactory, } from './loggerFactory/loggerFactory';
function configure(_a) {
    var _b = _a === void 0 ? {} : _a, level = _b.level, http = _b.http, console = _b.console;
    log.setDefaultLevel(level !== null && level !== void 0 ? level : 'info');
    var defaultLoggerFactory = log.methodFactory;
    var consoleLoggerFactory = createConsoleLoggerFactory(defaultLoggerFactory, console);
    if (http) {
        log.methodFactory = createHttpLoggerFactory(consoleLoggerFactory, __assign({}, http));
    }
    else {
        log.methodFactory = consoleLoggerFactory;
    }
    var defaultLogger = log.getLogger('default');
    return {
        getLogger: log.getLogger,
        getDefaultLogger: function () { return defaultLogger; },
    };
}
export { configure };
